import React from 'react'

const StocksDetailPage = React.lazy(() => import('pages/ReportInventory/ReportInventoryPage'));
// const StocksDetailProduct = React.lazy(() => import('pages/StocksDetail/StocksDetailProduct.js'));
// const StocksDetailHistory = React.lazy(() => import('pages/StocksDetail/StocksDetailHistory.js'));

const StocksDetailRoutes = [
    {
        path: '/report-stocks-detail',
        exact: true,
        name: 'Báo cáo tồn kho',
        function: 'ST_STOCKSDETAIL_VIEW',
        component: StocksDetailPage,
    },

//     {
//         path: '/stocks-detail/detail/:stocksId/:productId/:componentId',
//         exact: true,
//         name: 'Chi tiết tồn kho',
//         function: 'ST_STOCKSDETAIL_VIEW',
//         component: StocksDetailProduct,
//     },
//     {
//         path: '/stocks-detail/history/:productImeiCode',
//         exact: true,
//         name: 'Lịch sử lưu kho',
//         function: 'ST_STOCKSDETAIL_VIEW',
//         component: StocksDetailHistory,
//     },
]

export default StocksDetailRoutes
